
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiMapMarkerRadiusOutline } from "@mdi/js";
import CreateBuilding from "@/components/buildings/CreateBuilding.vue";
import ImportModal from "@/components/import/ImportModal.vue";
import { getMapLink } from "@/utils/misc";
import { ROWS_PER_PAGE } from "@/utils/constants";
import RequestTransfer from "@/components/buildings/RequestTransfer.vue";
import TransferBanner from "@/components/buildings/TransferBanner.vue";

const septeoImage = require("@/assets/images/septeo.png");

@Component({
  components: { SvgIcon, CreateBuilding, ImportModal, RequestTransfer, TransferBanner },
})
export default class Buildings extends Vue {

  @Getter private envCompanyId: number | null;
  @Getter private canDoInEnvCompany: (right: string) => boolean;

  private page: number = 1;
  private itemsPerPage: number = 10;
  private search: string = "";
  private loading: boolean = false;
  private mdiMapMarkerRadiusOutline = mdiMapMarkerRadiusOutline;
  private septeoImage = septeoImage;

  private buildingList: any[] = [];
  private totalItem: number = 0;

  private ROWS_PER_PAGE = ROWS_PER_PAGE;

  private headers: object[] = [
    { text: this.$t("Buildings.name"), value: "name", sortable: false },
    { text: this.$t("Buildings.address"), value: "address", sortable: false },
    { text: this.$t("Buildings.mapIcon"), value: "mapIcon", sortable: false },
    { text: "", value: "septeo", sortable: false },
  ];

  private mapLink = getMapLink;

  /**
   * Retrieves the nested value from an object based on the header value provided.
   *
   * @param {Object} item - The object containing nested values.
   * @param {Object} header - The header object specifying the value to retrieve.
   * @return {string} - The retrieved nested value as a string.
   */
  private getNestedValue(item, header) {
    switch (header.value) {
      case "address":
        return item.Address ? `${item.Address.name || ""} ${item.Address.address || ""}, ${item.Address.zipcode || ""}, ${item.Address.city || ""} ` : "";
      default:
        return item[header.value];
    }
  }

  /**
   * Handles options for the data table.
   *
   * @param {Object} event - The event object containing the page and itemsPerPage values.
   * @return {void}
   */
  private dataTableHandleOptions(event) {
    this.page = event.page;
    this.itemsPerPage = event.itemsPerPage;
    this.getBuildBingList();
  }

  /**
   * Clicks on a row, navigates to the building page with the given item's id as a parameter.
   *
   * @param {Object} item - The clicked row item.
   * @returns {Promise} - A promise representing the navigation action.
   */
  private clickRow(item) {
    return this.$router.push({ name: "building", params: { id: item.id } });
  }

  /**
   * Description: Handles the key press event for the 'Enter' key.
   *
   * @param {object} e - The event object representing the key press.
   *
   * @return {void}
   */
  private enterKeyPress(e) {
    if (e.keyCode === 13) {
      this.searchHandler();
    }
  }

  /**
   * Retrieves the company's building list from the store.
   *
   * @private
   * @returns {Promise} A promise that resolves to the building list.
   */
  private getBuildBingList() {
    this.loading = true;
    return this.$store.dispatch("companies/getCompanyBuildingList", {
      companyId: this.envCompanyId,
      search: this.search || null,
      page: this.page,
      itemsPerPage: this.itemsPerPage,
      notLinkToRelay: true,
    })
      .then((data) => {
        this.buildingList = data.rows;
        this.totalItem = data.count;
      })
      .finally(() => { this.loading = false; });
  }

  /**
   * Resets the search page to 1 and retrieves the Build Bing List.
   *
   * @returns {void}
   */
  private searchHandler(): void {
    this.page = 1;
    this.getBuildBingList();
  }
}
